import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import i18n from "./i18n"
import { isGranted } from "./cookieConsent"
import { enableAnalytics } from "./analytics"

Vue.config.productionTip = false

// Analitykę wczytujemy tylko, jeśli użytkownik zgodził się wcześniej.
if (isGranted()) enableAnalytics()

// Ekrany display to nasz wewnętrzny sprzęt, nie publiczna strona — tam śledzenie jest włączone
// zawsze, bez banera i niezależnie od zapisanej decyzji.
router.afterEach((to) => {
  if (to.meta.display) enableAnalytics()
})

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
